export default "__VITE_ASSET__01191479__"